import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { map } from 'lodash-es';

import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuHeader,
  MenuItem,
  useMenuProps,
} from '../../../../components/DropdownSet';

export const metricsToOptions = (metrics) =>
  map(metrics, (label, value) => ({
    label,
    value,
  }));

const MetricList = ({
  selected,
  options,
  disabled,
  menuWidth = 220,
  appendButtonText,
  className,
  onChange,
}) => {
  const menuProps = useMenuProps({
    align: 'start',
    menuStyle: { width: menuWidth },
    className,
  });

  const decoratedOptions = appendButtonText
    ? options.map((option) => ({
        ...option,
        buttonLabel: (
          <>
            <span>{option.label}</span>
            <span className="label-caption">{appendButtonText}</span>
          </>
        ),
      }))
    : options;

  const selectedOption = decoratedOptions.find((option) => option.value === selected) || {};

  const handleChange = ({ value }) => {
    onChange(value);
  };

  return (
    <div className={`metric-list-dropdown ${className || ''}`}>
      <Menu
        menuButton={
          <MenuButton disabled={disabled} frameless caret variant="transparent">
            {selectedOption.buttonLabel || selectedOption.label}
          </MenuButton>
        }
        {...menuProps}
      >
        {options.map(({ label, value, className: optionClassName }, index) => {
          if (value === 'divider') return <MenuDivider key={`divider-${index}`} fullWidth dense />;
          if (value === 'header') return <MenuHeader key={`header-${index}`}>{label}</MenuHeader>;

          const isActive = selectedOption.value === value;

          return (
            <MenuItem
              key={value}
              value={value}
              className={cx({ active: isActive }, optionClassName)}
              data-testid={value}
              onClick={(event) => !isActive && handleChange(event)}
            >
              {label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export const metricListPropTypes = {
  selected: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

MetricList.propTypes = {
  ...metricListPropTypes,
  appendButtonText: T.string,
  options: T.arrayOf(
    T.shape({
      label: T.string,
      value: T.string,
      className: T.string,
    })
  ).isRequired,
};

export default MetricList;
